<template>
  <div class="details-view">
    <cargo-left-right-resize
      :left-style="{flex:'none','width':'260px','max-width': '480px'}"
      :right-style="{'overflow': 'hidden'}"
      :show-left="action==='look' && !bpmLook"
      style="min-height: 100%"
    >
      <template slot="left">
        <cargo-ag-grid
          :show-side-bar="false"
          :grid-options="gridOptions"
          :row-data="rowData"
          class="section grid-fill"
          @gridReady="params=>{gridApi=params.api}"
        />
      </template>
      <template slot="right">
        <div class="main-content">
          <div class="operations" style="margin-bottom: 5px">
            <div class="triggers">
              <div v-show="action==='look' && !bpmLook">
                <el-button no="goBack" type="primary" @click="goBack">{{ $t('common.btn.back') }}</el-button>
                <el-button
                  v-show="isShowPartner"
                  v-permission="['write_SMPartner']"
                  no="editHandler"
                  :disabled="isEditPartner || (currentRow && Number(currentRow.approvedState) === 3)"
                  type="primary"
                  @click="editHandler"
                >{{ $t('common.btn.edit') }}</el-button>
                <el-button
                  v-if="partnersApproved > 0"
                  no="toAudit"
                  :disabled="!(auditBtnPermission && (currentRow && Number(currentRow.approvedState) === 0))"
                  type="primary"
                  @click="toAudit"
                >{{ $t('common.btn.audit') }}</el-button>
                <el-button
                  v-if="isCancelPartnersApproved"
                  no="toCancelAudit"
                  :disabled="!(cancelAuditBtnPermission && currentRow && Number(currentRow.approvedState) === 1)"
                  type="primary"
                  @click="toCancelAudit"
                >{{ $t('CargoMsg.Cargo_CancelAudit') }}</el-button>
                <el-button
                  v-permission="['button_SMPartner_cancelSpecial']"
                  no="specialFeeLimitApply"
                  type="primary"
                  @click="openSpecialFeeLimitApplyDialog"
                >{{ $t('CargoMsg.Cargo_SpecialFeeLimitReleaseApply') }}</el-button>
                <el-button v-permission="['button_SMPartner_releaseApplication']" type="primary" @click="releaseApplicationDialog.visible = true">{{ $t('CargoMsg.Cargo_TemporaryNumberReleaseApplication') }}</el-button>
              </div>
              <div v-show="action==='new'">
                <el-button no="goBack" type="primary" @click="goBack">{{ $t('common.btn.cancel') }}</el-button>
                <el-button
                  v-permission="['write_SMPartner']"
                  no="save"
                  type="primary"
                  @click="save"
                >{{ $t('common.btn.save') }}</el-button>
              </div>
              <div v-show="action==='edit'">
                <el-button no="againShow" type="primary" @click="againShow('look')">{{ $t('common.btn.cancel') }}</el-button>
                <el-button v-permission="['write_SMPartner']" no="partnerSave" type="primary" @click="save">{{ $t('common.btn.save') }}</el-button>
              </div>
            </div>
          </div>
          <div class="tabs-container">
            <el-tabs
              ref="tabs"
              v-model="activeTabName"
              type="card"
              style="width:100%;min-width:1000px"
              @tab-click="handleTabClick"
            >
              <el-tab-pane :key="1" name="basicInfo" :label="$t('baseInfo.partner.basicInfo.title')">
                <basic-info
                  ref="basicInfo"
                  :service-type="serviceType"
                  :action="action"
                  :current-row="currentRow"
                  :oujian-edit-limit="oujianEditLimit"
                  :is-sales-for-szfs="isSalesForSzfs"
                  @rowChange="onRowChange"
                />
              </el-tab-pane>
              <el-tab-pane v-if="!this.$checkPermission(['tab_hide_contact'], true)" :key="2" :lazy="true" name="contactForm" :label="$t('Payment.contactPerson')">
                <contact-form ref="contactForm" :action="canEditContact ? action : 'look'" />
              </el-tab-pane>
              <el-tab-pane v-if="paramsOfTab.customer && checkTabCustomer && (!this.$checkPermission(['tab_hide_customer'], true))" :key="3" :lazy="true" name="customerForm" :label="$t('Payment.customer')">
                <customer-form ref="customerForm" :action="canEditCustomer ? action : 'look'" :is-sales-for-szfs="isSalesForSzfs" />
              </el-tab-pane>
              <el-tab-pane :key="4" :lazy="true" :disabled="!canEditCredit" name="creditInfoForm" :label="$t('Partners.creditAccount')">
                <credit-info-form ref="creditInfoForm" :action="action" :branch-id="currentRow.branchId" :oujian-edit-limit="oujianEditLimit" />
              </el-tab-pane>
              <el-tab-pane v-if="$checkPermission(['tab_CustomerContractNumber'])" :key="5" :lazy="true" name="contractForm" :label="$t('Partners.contractNumber')">
                <contract-form ref="contractForm" :action="action" />
              </el-tab-pane>
              <el-tab-pane v-if="!!paramsOfTab.uuid && (!this.$checkPermission(['tab_hide_document'], true))" :key="5.5" :lazy="true" name="documentForm" :label="$t('Partners.documentation')">
                <document-form ref="documentForm" :action="canEditDocument ? action : 'look'" />
              </el-tab-pane>
              <el-tab-pane v-if="paramsOfTab.customer && checkTabCustomer && (!this.$checkPermission(['tab_hide_site'], true))" :key="6" :lazy="true" name="siteForm" :label="$t('Partners.doorInformation')">
                <site-form ref="siteForm" :action="canEditSite ? action : 'look'" />
              </el-tab-pane>
              <el-tab-pane v-if="paramsOfTab.customer && checkTabCustomer && (!this.$checkPermission(['tab_hide_specialRequest'], true))" :key="7" :lazy="true" name="specialRequestForm" :label="$t('Partners.specialRequirements')">
                <special-request-form ref="specialRequestForm" :action="canEditSpecialRequest ? action : 'look'" />
              </el-tab-pane>
              <el-tab-pane v-if="checkTabTitle && (!this.$checkPermission(['tab_hide_invoiceRequest'], true))" :key="8" :lazy="true" name="titleForm" :label="$t('Invoice.invoice_sp15')">
                <title-form ref="titleForm" :action="canEditInvoiceRequest ? action : 'look'" />
              </el-tab-pane>
              <!--供应链线路-->
              <el-tab-pane
                v-if="paramsOfTab.customer && checkSupplyChain && (!this.$checkPermission(['tab_hide_supplyChain'], true))"
                :key="8.5"
                :lazy="true"
                name="supplyChainForm"
                :label="$t('Partners.supplyChainLines')"
              >
                <supply-chain-form ref="supplyChainForm" :action="canEditSupplyChain ? action : 'look'" />
              </el-tab-pane>
              <!--              换单代理-->
              <el-tab-pane v-if="paramsOfTab.bookingAgent && checkTabBooking && (!this.$checkPermission(['tab_hide_exchangeAgent'], true))" :key="24" :lazy="true" name="exchangeAgentForm" :label="$t('SeaExport.BillExchangeAgent')">
                <exchange-agent-form ref="exchangeAgentForm" :action="canEditExchangeAgent ? action : 'look'" />
              </el-tab-pane>
              <!--              目的港操作代理-->
              <el-tab-pane v-if="paramsOfTab.overseaAgent && checkTabAgent && (!this.$checkPermission(['tab_hide_overseaAgent'], true))" :key="9" :lazy="true" name="overseaAgentForm" :label="$t('Partners.destinationPortHandlingAgent')">
                <oversea-agent-form ref="overseaAgentForm" :action="canEditOverseaAgent ? action : 'look'" />
              </el-tab-pane>
              <el-tab-pane v-if="paramsOfTab.designationAgent && checkTabAgent && (!this.$checkPermission(['tab_hide_designationAgent'], true))" :key="10" :lazy="true" name="designationAgentForm" :label="$t('Partners.destinationNominatedAgent')">
                <designation-agent-form ref="designationAgentForm" :action="canEditDesignationAgent ? action : 'look'" />
              </el-tab-pane>
              <el-tab-pane v-if="paramsOfTab.designationAgent && checkTabAgent && (!this.$checkPermission(['tab_hide_overseaAgentPort'], true))" :key="11" :lazy="true" name="overseaAgentPortForm" :label="$t('Partners.portLocation')">
                <oversea-agent-port-form ref="overseaAgentPortForm" :action="canEditOverseaAgentPort ? action : 'look'" />
              </el-tab-pane>
              <el-tab-pane v-if="paramsOfTab.bookingAgent && checkTabBooking && canCarrierCredit && (!this.$checkPermission(['tab_hide_bookingAgentCarrier'], true))" :key="12" :lazy="true" name="bookingAgentCarrierForm" :label="$t('Partners.spaceCarrier')">
                <booking-agent-carrier-form ref="bookingAgentCarrierForm" :action="canEditBookingAgentCarrier ? action : 'look'" />
              </el-tab-pane>
              <el-tab-pane
                v-if="(paramsOfTab.seaCmp||paramsOfTab.airCmp) && (checkTabShippingCompany || checkTabAirlineCompany) && (!this.$checkPermission(['tab_hide_carrierBookingAgent'], true))"
                :key="13"
                :lazy="true"
                name="carrierBookingAgentForm"
                :label="$t('Partners.spaceAgent')"
              >
                <carrier-booking-agent-form ref="carrierBookingAgentForm" :action="canEditCarrierBookingAgent ? action : 'look'" />
              </el-tab-pane>
              <el-tab-pane v-if="paramsOfTab.warehouse && checkTabWarehouse && (!this.$checkPermission(['tab_hide_warehouse'], true))" :key="14" :lazy="true" name="warehouseForm" :label="$t('Partners.warehouseInformation')">
                <warehouse-form ref="warehouseForm" :action="canEditWarehouse ? action : 'look'" />
              </el-tab-pane>
              <el-tab-pane v-if="paramsOfTab.airCmp && checkTabAirlineCompany && (!this.$checkPermission(['tab_hide_airline'], true))" :key="15" :lazy="true" name="airlineForm" :label="$t('SeaExport.AirlineCompany')">
                <airline-form ref="airlineForm" :action="canEditAirline ? action : 'look'" />
              </el-tab-pane>
              <el-tab-pane v-if="serviceType !== 'AIRLINE' && (!this.$checkPermission(['tab_hide_shipping'], true))" :key="16" :lazy="true" name="shippingForm" :label="$t('Partners.EDIConfiguration')">
                <shipping-form ref="shippingForm" :action="canEditShipping ? action : 'look'" :is-sales-for-szfs="isSalesForSzfs" />
              </el-tab-pane>
              <el-tab-pane
                v-if="(paramsOfTab.shipper||paramsOfTab.consignee||paramsOfTab.notify) && (!this.$checkPermission(['tab_hide_manifestAddress'], true))"
                :key="17"
                :lazy="true"
                name="manifestAddress"
                :label="$t('Partners.AddressInformation')"
              >
                <manifest-address-form ref="manifestAddress" :action="canEditManifestAddress ? action : 'look'" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!!paramsOfTab.uuid && isContractBinding && (!this.$checkPermission(['tab_hide_fclContractNoPrice'], true))"
                :key="19"
                name="navFclContractNoPrice"
                :label="$t('CargoMsg.Cargo_FclApproximatePrice')"
              >
                <tab-contract-no-price-fcl ref="navFclContractNoPrice" :action="canEditFclContractNoPrice ? action : 'look'" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!!paramsOfTab.uuid && isContractBinding && (!this.$checkPermission(['tab_hide_lclContractNoPrice'], true))"
                :key="20"
                name="navLclContractNoPrice"
                :label="$t('CargoMsg.Cargo_LclApproximatePrice')"
              >
                <tab-contract-no-price-lcl ref="navLclContractNoPrice" :action="canEditLclContractNoPrice ? action : 'look'" load-type="LCL" />
              </el-tab-pane>
              <!--事件记录页签-->
              <el-tab-pane v-if="!!paramsOfTab.uuid && $checkPermission(['tab_TabCustomerEvent'])" :key="21" name="navTabCustomerEvent" :label="$t('CargoMsg.Cargo_EventRecord')">
                <tab-customer-event ref="navTabCustomerEvent" :action="action" />
              </el-tab-pane>
              <!-- 子公司信息-->
              <el-tab-pane v-if="paramsOfTab.parentCompany && (!this.$checkPermission(['tab_hide_subsidiaryInformation'], true))" :key="22" :lazy="true" name="subsidiaryInformation" :label="$t('Partners.subsidiaryInformation')">
                <subsidiary-information ref="subsidiaryInformation" :action="canEditSubsidiaryInformation ? action : 'look'" />
              </el-tab-pane>
              <!--码头公司页签-->
              <el-tab-pane v-if="paramsOfTab.terminalCompany && (!this.$checkPermission(['tab_hide_terminalCompany'], true))" :key="23" name="terminalCompany" :label="$t('Message.TerminalCompany')">
                <terminal-company ref="terminalCompany" :action="canEditTerminalCompany ? action : 'look'" />
              </el-tab-pane>
              <el-tab-pane v-if="paramsOfTab.truckCmp && (!this.$checkPermission(['tab_hide_driverInformation'], true))" :key="25" :lazy="true" name="driverInformationForm" :label="$t('Partners.DriverInformation')">
                <driver-information-form ref="driverInformationForm" :action="canEditDriverInformation ? action : 'look'" />
              </el-tab-pane>
              <!--客商打分-->
              <el-tab-pane v-if="hasUiConfig && (!this.$checkPermission(['tab_hide_customerVendorRating'], true))" :key="26" name="customerVendorRating" :label="$t('CargoMsg.Cargo_CustomerVendorRating')">
                <customer-vendor-rating ref="customerVendorRating" :action="canEditCustomerVendorRating ? action : 'look'" />
              </el-tab-pane>
              <el-tab-pane v-if="paramsOfTab.truckCmp && (!this.$checkPermission(['tab_hide_truckClassification'], true))" :key="27" :lazy="true" name="truckClassificationForm" :label="'车队分类'">
                <truck-classification-form ref="truckClassificationForm" :action="canEditTruckClassification ? action : 'look'" />
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </template>
    </cargo-left-right-resize>
    <!-- 验证规则弹窗 -->
    <checking-save-job-window
      v-if="checkingSaveJobWindow.visible"
      :visible.sync="checkingSaveJobWindow.visible"
      :lob="checkingSaveJobWindow.lob"
      :row-data="checkingSaveJobWindow.rowData"
      :check-node="checkingSaveJobWindow.checkNode"
      :call-back="checkingSaveJobWindow.callBack"
    />

    <!-- 专项费用限制解除申请 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="specialFeeLimitApplyDialog.visible"
      :title="$t('CargoMsg.Cargo_SpecialFeeLimitReleaseApply')"
      width="600px"
      :close-on-click-modal="false"
      :show-close="false"
      @closed="resetSpecialFeeLimitApplyDialog"
    >
      <el-form
        ref="specialFeeLimitApplyForm"
        :model="specialFeeLimitApplyDialog.form"
        :rules="specialFeeLimitApplyRules"
        label-width="90px"
        label-position="right"
      >
        <el-form-item :label="$t('Partners.chineseName')">
          <el-input v-model="specialFeeLimitApplyDialog.form.chineseName" disabled />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Application_Content')" prop="applyContent">
          <el-input v-model="specialFeeLimitApplyDialog.form.applyContent" type="textarea" :rows="4" />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Application_Reason')" prop="applyReason">
          <el-input v-model="specialFeeLimitApplyDialog.form.applyReason" type="textarea" :rows="4" />
        </el-form-item>
        <el-form-item :label="$t('Pricing.Attachment')">
          <div class="upload-file-row">
            <template v-if="hasSpecialFeeLimitUploadedFile">
              <span class="upload-file-name">{{ getSpecialFeeLimitUploadedFileName() }}</span>
              <el-button class="upload-file-remove" type="text" icon="el-icon-close" @click="handleRemoveSpecialFeeLimitUpload" />
            </template>
            <el-button v-else size="small" type="primary" @click="cloudFile.visible = true">
              {{ $t('CargoMsg.Cargo_Upload') }}
            </el-button>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align: center;">
        <el-button no="submitSpecialFeeLimitApply" type="primary" @click="submitSpecialFeeLimitApply">{{ $t('CargoMsg.Cargo_Submit') }}</el-button>
        <el-button no="cancelSpecialFeeLimitApply" @click="specialFeeLimitApplyDialog.visible = false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>

    <!-- 放单申请弹窗 -->
    <release-application-dialog :visible.sync="releaseApplicationDialog.visible" :cmp-idx="currentRow.cmpIdx" />

    <!-- 云文件上传对话框（专项费用限制解除申请） -->
    <cargo-cloud-file-upload
      :visible.sync="cloudFile.visible"
      :job="cloudFile.job"
      :lob="cloudFile.lob"
      @uploadDone="data => { uploadSpecialFeeLimitFileSuccess(data) }"
    />
  </div>
</template>

<script>
import CargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'
import basicInfo from './tab/basicInfo'
import contactForm from './tab/contactForm'
import customerForm from './tab/customerForm'
import creditInfoForm from './tab/creditInfoForm'
import contractForm from './tab/contractForm'
import documentForm from './tab/documentForm'
import siteForm from './tab/siteForm'
import specialRequestForm from './tab/specialRequestForm'
import titleForm from './tab/titleForm'
import overseaAgentForm from './tab/overseaAgentForm'
import designationAgentForm from './tab/designationAgentForm'
import overseaAgentPortForm from './tab/overseaAgentPortForm'
import bookingAgentCarrierForm from './tab/bookingAgentCarrierForm'
import carrierBookingAgentForm from './tab/carrierBookingAgentForm'
import warehouseForm from './tab/warehouseForm'
import airlineForm from './tab/airlineForm'
import shippingForm from './tab/shippingForm'
import manifestAddressForm from './tab/manifestAddressForm'
import supplyChainForm from './tab/supplyChainForm'
import TabContractNoPriceFcl from './tab/tabContractNoPriceFcl'
import TabContractNoPriceLcl from './tab/tabContractNoPriceLcl'
import lodash from 'lodash'
import { TabError } from '@/utils/class/TabError'
import { cache, cacheName } from '@/utils/cacheManager'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import { sleep, ensureExecuteSuccess } from '@/utils/commonUtil'
import { updateBasicDataForSingle } from '@/utils/basicDataCache'
import { Company } from '@/class/model/mdm/Company'
import { CreditInfo } from '@/class/model/sys/CreditInfo'
import { OverseaAgent } from '@/class/model/sys/OverseaAgent'
import * as PartnerServiceItem from '@/class/cargo/model/parameters/PartnerServiceItem'
import {
  checkOtherCompanySettleAgent,
  saveCompanyInfo, validateCompany,
  validateCompanyByChineseNameFunc,
  hasPartnerPrivilegeBranches, validateCustomerCode, cancelAuditCompany
} from '@/api/company'
import TabCustomerEvent from '@/views/cargo/v0/Information/components/partner/tab/tabCustomerEvent'
import $store from '@/store'
import subsidiaryInformation from '@/views/cargo/v0/Information/components/partner/tab/subsidiaryInformation'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { localCurrencyByOffice } from '@/class/cargo/model/utils/RateUtil'
import terminalCompany from '@/views/cargo/v0/Information/components/partner/tab/terminalCompany'
import { getDefaultCreditInfo } from '@/api/partner/creditInfo'
import ExchangeAgentForm from '@/views/cargo/v0/Information/components/partner/tab/exchangeAgentForm'
import * as CheckRuleConstants from '@/class/cargo/model/parameters/CheckRuleConstants'
import { checkAnyContent } from '@/api/sysManage/baseConfig/checkRuleConfig'
import checkingSaveJobWindow from '@/components/Cargo/Job/CheckingManager/CheckingSaveJobWindow'
import { areAllExcludedOffices } from '@/api/sysManage/baseConfig/ExclusionOffice'
import DriverInformationForm from '@/views/cargo/v0/Information/components/partner/tab/driverInformationForm'
import TruckClassificationForm from '@/views/cargo/v0/Information/components/partner/tab/truckClassificationForm'
import CustomerVendorRating from '@/views/cargo/v0/Information/components/partner/tab/customerVendorRating.vue'
import { initiateSpecialApprovalFunc } from '@/api/clearing/billPayment'
import cargoCloudFileUpload from '@/components/Cargo/Common/cargoCloudFileUpload.vue'
import { Project } from '@/class/model/pm/Project'
import ReleaseApplicationDialog from '@/views/cargo/v0/Information/components/partner/tab/releaseApplicationDialog.vue'
import { getSupplierDepartmentPermissions } from '@/api/partner/permissionCheck'

export default {
  name: 'PartnerForm',
  components: {
    ReleaseApplicationDialog,
    CustomerVendorRating,
    ExchangeAgentForm, DriverInformationForm, TruckClassificationForm,
    TabCustomerEvent, checkingSaveJobWindow,
    cargoCloudFileUpload,
    CargoLeftRightResize, basicInfo, contactForm, customerForm, creditInfoForm, contractForm, documentForm, siteForm, specialRequestForm,
    titleForm, overseaAgentForm, designationAgentForm, overseaAgentPortForm, bookingAgentCarrierForm, carrierBookingAgentForm, warehouseForm,
    airlineForm, shippingForm, manifestAddressForm, supplyChainForm, TabContractNoPriceFcl, TabContractNoPriceLcl, subsidiaryInformation, terminalCompany
  },
  props: {
    serviceType: { type: String, default: '' },
    isSalesForSzfs: { type: Boolean, default: false } // 深圳丰收销售专用
  },
  data() {
    const isZh = this.$store.getters.language === 'zh'
    return {
      action: '',
      partnersApproved: 0,
      isContractBinding: false,
      jinRongExchangeMode: false, // 锦荣交单模式
      hmToFinanceApi: false,
      bpmLook: false,
      isSales: false,
      contractNumberTab: false,
      editContract: false,
      oldData: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        suppressContextMenu: true,
        treeData: true,
        groupDefaultExpanded: 2,
        getDataPath: data => {
          return data.path.split(',')
        },
        autoGroupColumnDef: {
          headerName: this.$t('Partners.parter'),
          colId: isZh ? 'chineseName' : 'englishName',
          field: isZh ? 'chineseName' : 'englishName',
          width: 200,
          suppressMenu: true,
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: true,
            innerRenderer: params => {
              return params.value
            }
          },
          tooltip: params => {
            return isZh ? params.data.chineseName : params.data.englishName
          }
        },
        columnDefs: [],
        onRowDataChanged: event => {
          event.api.clearFocusedCell()
        },
        onCellFocused: event => {
          const nodes = event.api.rowModel.rowsToDisplay
          this.selectedNode = nodes[event.rowIndex] || null
        },
        onRowClicked: this.onRowClicked,
        onSortChanged: event => {
          if (this.selectedNode) {
            event.api.setFocusedCell(this.selectedNode.rowIndex, event.columnApi.getAllDisplayedColumns()[0])
          }
        },
        context: {
          componentParent: this
        }
      },
      rowData: [],
      selectedNode: null,
      gridApi: null,
      currentRow: {},
      paramsOfTab: {},
      pendTabSet: new Set(),
      activeTabName: 'basicInfo',
      hasUiConfig: false,
      detailWidth: 300,
      partnerPrivilegeBranches: null,
      checkingSaveJobWindow: {
        lob: '',
        visible: false,
        checkNode: 0,
        callBack: null,
        rowData: []
      },
      specialFeeLimitApplyDialog: {
        visible: false,
        form: {
          billPaymentUuid: '',
          cmpIdx: '',
          chineseName: '',
          applyMatter: '专项费用限制解除申请',
          contextData: '',
          fileList: [],
          applyContent: '',
          applyReason: ''
        }
      },
      cloudFile: {
        visible: false,
        job: new Project(),
        lob: 'allLob'
      },
      isCancelPartnersApproved: false, // 合作伙伴“取消审核”按钮 当参数PartnersApproved配置等于1/2/3时，显示此按钮。
      isXy: false,
      showIfRisk: false,
      releaseApplicationDialog: {
        visible: false
      },
      // 供应商所属部门权限缓存
      supplierDepartmentPermissions: {},
      // 是否已加载权限
      permissionsLoaded: false
    }
  },
  computed: {
    checkTabCustomer() {
      return this.serviceType === PartnerServiceItem.PARTNER_CUSTOMER.code || this.serviceType === PartnerServiceItem.PARTNER_SERVICE_ALL.code
    },
    checkTabTitle() {
      return this.serviceType === PartnerServiceItem.PARTNER_CUSTOMER.code || PartnerServiceItem.PARTNER_COMPANY_FACTORY_MANUFACTURER.code || this.serviceType === PartnerServiceItem.PARTNER_SERVICE_ALL.code
    },
    checkTabAgent() {
      return this.serviceType === PartnerServiceItem.PARTNER_AGENT.code || this.serviceType === PartnerServiceItem.PARTNER_SERVICE_ALL.code
    },
    checkTabBooking() {
      return this.serviceType === PartnerServiceItem.PARTNER_BOOKING.code || this.serviceType === PartnerServiceItem.PARTNER_SERVICE_ALL.code
    },
    checkTabShippingCompany() {
      return this.serviceType === PartnerServiceItem.SHIPPING_COMPANY.code || this.serviceType === PartnerServiceItem.PARTNER_SERVICE_ALL.code
    },
    checkTabAirlineCompany() {
      return this.serviceType === PartnerServiceItem.AIRLINE_COMPANY.code || this.serviceType === PartnerServiceItem.PARTNER_SERVICE_ALL.code
    },
    checkTabWarehouse() {
      return this.serviceType === PartnerServiceItem.PARTNER_WAREHOUSE.code || this.serviceType === PartnerServiceItem.PARTNER_SERVICE_ALL.code
    },
    // Tab 供应链线路
    checkSupplyChain() {
      return this.serviceType === PartnerServiceItem.PARTNER_CUSTOMER.code || this.serviceType === PartnerServiceItem.PARTNER_SERVICE_ALL.code
    },
    canEditCredit() {
      return this.$checkPermission(['tab_SMPartner_credit'])
    },
    canEditContact() {
      return this.$checkPermission(['tab_edit_contact'])
    },
    canEditCustomer() {
      return this.$checkPermission(['tab_edit_customer'])
    },
    canEditDocument() {
      return this.$checkPermission(['tab_edit_document'])
    },
    canEditSite() {
      return this.$checkPermission(['tab_edit_site'])
    },
    canEditSpecialRequest() {
      return this.$checkPermission(['tab_edit_specialRequest'])
    },
    canEditInvoiceRequest() {
      return this.$checkPermission(['tab_edit_invoiceRequest'])
    },
    canEditSupplyChain() {
      return this.$checkPermission(['tab_edit_supplyChain'])
    },
    canEditExchangeAgent() {
      return this.$checkPermission(['tab_edit_exchangeAgent'])
    },
    canEditOverseaAgent() {
      return this.$checkPermission(['tab_edit_overseaAgent'])
    },
    canEditDesignationAgent() {
      return this.$checkPermission(['tab_edit_designationAgent'])
    },
    canEditOverseaAgentPort() {
      return this.$checkPermission(['tab_edit_overseaAgentPort'])
    },
    canEditBookingAgentCarrier() {
      return this.$checkPermission(['tab_edit_bookingAgentCarrier'])
    },
    canEditCarrierBookingAgent() {
      return this.$checkPermission(['tab_edit_carrierBookingAgent'])
    },
    canEditWarehouse() {
      return this.$checkPermission(['tab_edit_warehouse'])
    },
    canEditAirline() {
      return this.$checkPermission(['tab_edit_airline'])
    },
    canEditShipping() {
      return this.$checkPermission(['tab_edit_shipping'])
    },
    canEditManifestAddress() {
      return this.$checkPermission(['tab_edit_manifestAddress'])
    },
    canEditFclContractNoPrice() {
      return this.$checkPermission(['tab_edit_fclContractNoPrice'])
    },
    canEditLclContractNoPrice() {
      return this.$checkPermission(['tab_edit_lclContractNoPrice'])
    },
    canEditSubsidiaryInformation() {
      return this.$checkPermission(['tab_edit_subsidiaryInformation'])
    },
    canEditTerminalCompany() {
      return this.$checkPermission(['tab_edit_terminalCompany'])
    },
    canEditDriverInformation() {
      return this.$checkPermission(['tab_edit_driverInformation'])
    },
    canEditCustomerVendorRating() {
      return this.$checkPermission(['tab_edit_customerVendorRating'])
    },
    canEditTruckClassification() {
      return this.$checkPermission(['tab_edit_truckClassification'])
    },
    canCarrierCredit() {
      return this.$checkPermission(['button_SMPartner_lookCarrier']) || this.$checkPermission(['button_SMPartner_editCarrier'])
    },
    // 检查供应商所属部门权限
    checkSupplierDepartmentPermission(departmentId) {
      const permissionKey = `supplier_department_${departmentId}`
      return this.supplierDepartmentPermissions[permissionKey] || false
    },
    isShowPartner() {
      // 当“PartnersApproved”=3时，合作伙伴“审核状态”=已审核 不显示详情页“编辑”按钮
      return !(this.partnersApproved === 3 && this.currentRow && Number(this.currentRow.approvedState) === 1)
    },
    isEditPartner() {
      // CARGO-43014 增加编辑HQ分公司合作伙伴编辑权限
      return !(this.$store.getters.isAdmin ||
        this.$checkPermission(['button_SMPartner_HQReadOnly']) && this.$store.getters.currentOfficeId === this.currentRow.branchId ||
        !this.$checkPermission(['button_SMPartner_HQReadOnly']))
    },
    // CARGO-45565 客商数据CargoWare读取欧坚数据库
    oujianEditLimit() {
      return this.action === 'edit' && this.showIfRisk
    },
    auditBtnPermission() {
      return this.$checkPermission(['button_SMPartner_partnersApproved']) || (this.$checkPermission(['button_SMPartner_customerApproved']) && this.$checkPermission(['button_SMPartner_supplierApproved']) && this.serviceType === PartnerServiceItem.PARTNER_SERVICE_ALL.code) ||
        (this.$checkPermission(['button_SMPartner_customerApproved']) && this.serviceType === PartnerServiceItem.PARTNER_SERVICE_ALL.code && !this.isSupplier) ||
        (this.$checkPermission(['button_SMPartner_supplierApproved']) && this.serviceType === PartnerServiceItem.PARTNER_SERVICE_ALL.code && !this.isCustomer)
    },
    cancelAuditBtnPermission() {
      return this.$checkPermission(['button_SMPartner_partnersCancelAudit']) || (this.$checkPermission(['button_SMPartner_customerCancelApproved']) && this.$checkPermission(['button_SMPartner_supplierCancelApproved']) && this.serviceType === PartnerServiceItem.PARTNER_SERVICE_ALL.code) ||
        (this.$checkPermission(['button_SMPartner_customerCancelApproved']) && this.serviceType === PartnerServiceItem.PARTNER_SERVICE_ALL.code && !this.isSupplier) ||
        (this.$checkPermission(['button_SMPartner_supplierCancelApproved']) && this.serviceType === PartnerServiceItem.PARTNER_SERVICE_ALL.code && !this.isCustomer)
    },
    isCustomer() {
      return this.currentRow.customer || this.currentRow.seaCmp || this.currentRow.airCmp || this.currentRow.shipper || this.currentRow.consignee ||
        this.currentRow.notify || this.currentRow.tradersSign || this.currentRow.factorySign || this.currentRow.other
    },
    isSupplier() {
      return this.currentRow.bookingAgent || this.currentRow.seaCmpAgent || this.currentRow.overseaAgent || this.currentRow.designationAgent ||
        this.currentRow.localAgent || this.currentRow.settlementAgent || this.currentRow.customsBroker || this.currentRow.warehouse ||
        this.currentRow.truckCmp || this.currentRow.portAgent || this.currentRow.forwardingAgent || this.currentRow.loadingPlaceCompany ||
        this.currentRow.signBillPlaceCompany || this.currentRow.dischargePortCompany || this.currentRow.destinationPortCompany || this.currentRow.terminalCompany
    },
    specialFeeLimitApplyRules() {
      return {
        applyContent: [{ required: true, message: this.$t('CargoMsg.Validation_ApplicationContentRequired'), trigger: 'blur' }],
        applyReason: [{ required: true, message: this.$t('CargoMsg.Validation_ApplicationReasonRequired'), trigger: 'blur' }]
      }
    },
    hasSpecialFeeLimitUploadedFile() {
      return !!(this.specialFeeLimitApplyDialog &&
        this.specialFeeLimitApplyDialog.form &&
        Array.isArray(this.specialFeeLimitApplyDialog.form.fileList) &&
        this.specialFeeLimitApplyDialog.form.fileList.length > 0)
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.isCancelPartnersApproved = [1, 2, 3, 4].includes(Number(cache.config.get('PartnersApproved'))) // 合作伙伴“取消审核”按钮 当参数PartnersApproved配置等于1/2/3/4时，显示此按钮。
    this.showIfRisk = (Number(cache.config.get('oujianPartner')) === 1) // CARGO-45565【欧坚客户化】数据库抓起限制“合作伙伴”
    this.hasUiConfig = (Number(cache.config.get('UICustomization')) === 1) // 有没有开启UI自定义
    this.contractNumberTab = this.$checkPermission(['tab_CustomerContractNumber']) // 查看合同约号页签
    this.editContract = this.$checkPermission(['button_ContractManagement_editContract']) // 上传文件 删除文件权限
    await this.loadPartnerPermissions()
  },
  updated() {
    if (!this.$refs['tabs']) {
      return
    }
    const panes = this.$refs['tabs'].panes
    const tabNameSet = new Set()
    for (const item of panes) {
      tabNameSet.add(item.name)
    }
    // 将失效的tab名称从pendTabSet中移除
    for (const item of [...this.pendTabSet]) {
      if (!tabNameSet.has(item)) {
        this.pendTabSet.delete(item)
      }
    }
  },
  methods: {
    async loadPartnerPermissions() {
      try {
        const deptRes = await getSupplierDepartmentPermissions()
        if (deptRes && deptRes.data) {
          this.supplierDepartmentPermissions = deptRes.data
        }
        this.permissionsLoaded = true
      } catch (e) {
        console.error('加载供应商所属部门权限失败:', e)
      }
    },
    openSpecialFeeLimitApplyDialog() {
      const chineseName = (this.currentRow && this.currentRow.chineseName) ? String(this.currentRow.chineseName) : ''
      const applyContent = chineseName
        ? this.$t('CargoMsg.Cargo_SpecialFeeLimitReleaseApplyContent', [chineseName])
        : this.$t('CargoMsg.Cargo_SpecialFeeLimitReleaseApplyContentPlain')
      Object.assign(this.specialFeeLimitApplyDialog.form, {
        billPaymentUuid: (this.currentRow && this.currentRow.uuid) || '',
        cmpIdx: (this.currentRow && this.currentRow.cmpIdx) || '',
        chineseName,
        applyMatter: '其他事项',
        contextData: JSON.stringify({ type: 'customer', uuid: (this.currentRow && this.currentRow.uuid) || '' }),
        fileList: [],
        applyContent,
        applyReason: ''
      })
      this.specialFeeLimitApplyDialog.visible = true
      this.$nextTick(() => {
        if (this.$refs.specialFeeLimitApplyForm) {
          this.$refs.specialFeeLimitApplyForm.clearValidate()
        }
      })
    },
    resetSpecialFeeLimitApplyDialog() {
      Object.assign(this.specialFeeLimitApplyDialog.form, {
        billPaymentUuid: '',
        cmpIdx: '',
        chineseName: '',
        applyMatter: '其他事项',
        contextData: '',
        fileList: [],
        applyContent: '',
        applyReason: ''
      })
      this.cloudFile.visible = false
      if (this.$refs.specialFeeLimitApplyForm) {
        this.$refs.specialFeeLimitApplyForm.resetFields()
      }
    },
    // 上传文件后会回调
    async uploadSpecialFeeLimitFileSuccess(rowData) {
      try {
        const fileInfoList = []
        for (const item of rowData || []) {
          if (item && item.fileId) {
            fileInfoList.push({
              fileId: item.fileId,
              fileName: item.fileName || item.name || ''
            })
          }
        }
        this.specialFeeLimitApplyDialog.form.fileList = fileInfoList
        this.cloudFile.visible = false
      } catch (e) {
        console.log(e)
      }
    },
    getSpecialFeeLimitUploadedFileName() {
      const files = (this.specialFeeLimitApplyDialog && this.specialFeeLimitApplyDialog.form && this.specialFeeLimitApplyDialog.form.fileList) || []
      const names = files.map(f => f && f.fileName).filter(Boolean)
      if (names.length > 0) {
        return names.join(', ')
      }
      return this.$t('SeaExport.UploadedFile')
    },
    handleRemoveSpecialFeeLimitUpload() {
      this.specialFeeLimitApplyDialog.form.fileList = []
    },
    async submitSpecialFeeLimitApply() {
      const formRef = this.$refs.specialFeeLimitApplyForm
      if (!formRef) return

      const valid = await new Promise(resolve => {
        formRef.validate(ok => resolve(ok))
      })
      if (!valid) return

      const payload = {
        // 保持字段名与现有“特殊审批”接口一致，同时补充合作伙伴信息，便于后端扩展/区分
        applyMatter: this.specialFeeLimitApplyDialog.form.applyMatter,
        applyContent: this.specialFeeLimitApplyDialog.form.applyContent,
        applyReason: this.specialFeeLimitApplyDialog.form.applyReason,
        billPaymentUuid: this.specialFeeLimitApplyDialog.form.billPaymentUuid,
        cmpIdx: this.specialFeeLimitApplyDialog.form.cmpIdx,
        chineseName: this.specialFeeLimitApplyDialog.form.chineseName,
        contextData: this.specialFeeLimitApplyDialog.form.contextData,
        fileList: (this.specialFeeLimitApplyDialog.form.fileList || []).map(f => (f && f.fileId) || f).filter(Boolean)
      }

      const loading = getLoading4Cxt(this)
      try {
        const res = await initiateSpecialApprovalFunc(payload)
        if (res && res.ok === false) {
          this.$message.error(res.message || this.$t('CargoMsg.Cargo_ProcessFailed'))
          return
        }
        this.$message.success(this.$t('CargoMsg.Cargo_SubmittedSuccessfully'))
        this.specialFeeLimitApplyDialog.visible = false
      } catch (err) {
        this.$message.error((err && err.message) || this.$t('CargoMsg.Cargo_ProcessFailed'))
      } finally {
        loading.close()
      }
    },
    async onShow(action, rowData, row) {
      this.partnersApproved = Number(cache.config.get('PartnersApproved'))
      this.isContractBinding = Number(cache.config.get('ContractBinding')) === 1
      this.jinRongExchangeMode = cache.config.get('ToExoSystem') === 'JinRongExchangeMode' // 锦荣交单模式
      this.isXy = cache.config.get('ToExoSystem') === 'XYCW'
      this.hmToFinanceApi = cache.hqConfig.get('ToFinanceApi') === 'HM' // 上海虹迈
      this.bpmView = false
      if (action === 'bpmLook') {
        this.action = 'look'
        this.bpmLook = true
      } else {
        this.action = action
      }
      this.oldData = row
      if (row && !rowData.find(params => params.chineseName === row.chineseName)) {
        rowData.push(row)
      }
      this.rowData = rowData
      if (!row) {
        row = this.$refs.basicInfo.getNewForm()
        this.changeCompanyServiceItem(row)
        row.path = ''
        this.rowData.push(row)
        this.activeTabName = 'basicInfo'
      }
      if (this.gridApi) {
        await sleep(100)
      } else {
        // 等待gridApi被赋值
        await ensureExecuteSuccess(() => this.gridApi)
      }
      if (!this.partnerPrivilegeBranches) {
        await hasPartnerPrivilegeBranches().then(res => {
          this.partnerPrivilegeBranches = res.data
        })
      }
      this.setGridSelect(row)
      await this.onRowClicked({ data: row })
    },
    /**
		 * 新增时默认值
		 * 订舱：订舱代理，船公司，航空公司
		 * 报关：报关行
		 * 仓储：仓库
		 * 运输：车队
		 * 其它：其它
		 * 客户：客户
		 * 代理：目的港代理，指定货代理
		 */
    changeCompanyServiceItem(company) {
      switch (this.serviceType) {
        case PartnerServiceItem.PARTNER_BOOKING.code:
          company.bookingAgent = true
          break
        case PartnerServiceItem.SHIPPING_COMPANY.code:
          company.seaCmp = true
          break
        case PartnerServiceItem.AIRLINE_COMPANY.code:
          company.airCmp = true
          break
        case PartnerServiceItem.PARTNER_AGENT.code:
          company.overseaAgent = true
          company.designationAgent = true
          break
        case PartnerServiceItem.PARTNER_CUSTOMER.code:
          company.customer = true
          break
        case PartnerServiceItem.PARTNER_CUSTOMS_BROKER.code:
          company.customsBroker = true
          break
        case PartnerServiceItem.PARTNER_WAREHOUSE.code:
          company.warehouse = true
          break
        case PartnerServiceItem.PARTNER_TRUCK.code:
          company.truckCmp = true
          break
        case PartnerServiceItem.PARTNER_OTHER.code:
          company.other = true
          break
        case PartnerServiceItem.PARTNER_COMPANY_FACTORY_MANUFACTURER.code:
          company.factorySign = true
          break
        default:
          break
      }
    },
    // 设置选中行
    setGridSelect(row) {
      const nodes = this.gridApi.rowModel.rowsToDisplay
      for (const item of nodes) {
        if (item.data.uuid === row.uuid || !item.data.uuid) {
          this.gridApi.setFocusedCell(item.rowIndex, this.gridApi.columnController.getAllDisplayedColumns()[0])
          break
        }
      }
    },
    async onRowClicked(event) {
      this.currentRow = event.data
      await this.getRelatedInfo()
      this.resetParamsOfTab()
      this.pendTabSet.clear()
      this.$nextTick(() => {
        const activePanes = this.$refs['tabs'].panes.filter(p => p.active)
        if (activePanes && activePanes.length === 0) {
          this.activeTabName = 'basicInfo'
        }
        this.handleTabClick()
      })
    },
    resetParamsOfTab() {
      this.paramsOfTab = this.action === 'edit' ? lodash.cloneDeep(this.currentRow) : this.currentRow
    },
    async getRelatedInfo() {
      const customer = {
        uuid: '',
        customerTypeId: 0,
        ownerType: 0,
        ownerClass: 0,
        designated: false,
        seftCanvass: this.action === 'new' && this.isXy,
        peer: false,
        sales: 0,
        ownerDepartment: 0,
        invoiceMode: 0,
        overInvoicing: false,
        invoiceRemarks: '',
        priceLevel: 0,
        iTraceService: false,
        currencyRequirements: 0,
        appointCurrency: localCurrencyByOffice(),
        iTraceStartDate: '',
        oversea: '',
        companyUuid: this.currentRow.uuid
      }
      if (this.isSalesForSzfs) {
        customer.seftCanvass = true
      }
      this.currentRow.customerDetail = customer
      if (this.currentRow.uuid) {
        let data = {}
        const params = {
          companyUuid: this.currentRow.uuid,
          company: true,
          creditInfo: true,
          customer: true,
          contact: true,
          overseaAgents: true,
          bookingAgentList: true,
          carrierList: true,
          events: true,
          subsidiaryCompany: true,
          exChangeAgent: true,
          truckCmp: true,
          taxInvoiceList: true
        }
        data = await Company.loadCompanyRelatedByParams(params)
        if (data.company) {
          this.currentRow.linkedBranchId = data.company.linkedBranchId
          this.currentRow.version = data.company.version
        }
        if (data.customer && data.customer.length > 0) {
          Object.assign(customer, data.customer[0])
        }
        this.currentRow.contacts = data.contact
        if (data.creditInfo && data.creditInfo.length > 0) {
          this.currentRow.creditInfo = data.creditInfo[0]
        }
        if (data.hasOwnProperty('overseaAgents') && data.overseaAgents.length > 0) {
          this.currentRow.overseaAgentDetail = data.overseaAgents[0]
        }
        this.currentRow.bookingAgentList = data.bookingAgentList
        this.currentRow.carrierList = data.carrierList
        this.currentRow.events = data.events
        this.currentRow.subsidiaryCompanyList = data.subsidiaryCompanyList
        this.currentRow.exChangeAgentList = data.exChangeAgentList
        this.currentRow.driverInformationList = data.driverInformationList
        this.currentRow.truckClassificationList = data.truckClassificationList
        this.currentRow.taxInvoiceList = data.taxInvoiceList || []
        this.currentRow.supplierDepartmentUuids = data.supplierDepartmentUuids || []
      } else {
        this.currentRow.contacts = []
        this.currentRow.bookingAgentList = []
        this.currentRow.carrierList = []
        this.currentRow.events = []
        this.currentRow.subsidiaryCompanyList = []
        this.currentRow.exChangeAgentList = []
        this.currentRow.driverInformationList = []
        this.currentRow.truckClassificationList = []
        this.currentRow.taxInvoiceList = []
      }
      if (!this.currentRow.creditInfo) {
        this.currentRow.creditInfo = await this.getCreditInfo()
      }
      if (!this.currentRow.overseaAgentDetail) {
        this.currentRow.overseaAgentDetail = new OverseaAgent().fillDefaultValue().getData()
      }
      if (!this.currentRow.hasOwnProperty('addedSubsidiaryCompanyKeys')) {
        this.currentRow.addedSubsidiaryCompanyKeys = []
      }
      if (!this.currentRow.hasOwnProperty('deletedSubsidiaryCompanyKeys')) {
        this.currentRow.deletedSubsidiaryCompanyKeys = []
      }
    },
    handleTabClick() {
      this.$nextTick(() => {
        const oldSize = this.pendTabSet.size
        this.pendTabSet.add(this.activeTabName)
        const isRefresh = this.pendTabSet.size > oldSize
        this.$refs[this.activeTabName].onShow(this.paramsOfTab, isRefresh)
      })
    },
    async againShow(action) {
      if (action === 'new') {
        this.onShow(action, this.rowData)
      } else {
        this.onShow(action, this.rowData, this.currentRow)
      }
    },
    async save() {
      let loading = getLoading4Cxt(this)
      try {
        const body = { companyUuid: this.currentRow.uuid, cmpIdx: this.currentRow.cmpIdx, officeId: this.$store.getters.currentOfficeId }
        const tabNames = [...this.pendTabSet]
        for (const item of tabNames) {
          const getSubmitData = this.$refs[item].getSubmitData
          if (item === 'airlineForm' && !tabNames.includes('basicInfo')) {
            let tabData = null
            const result = this.$refs['basicInfo'].getSubmitData()
            if (result instanceof Promise) {
              tabData = await result
            } else {
              tabData = result
            }
            Object.assign(body, tabData)
          }
          if (getSubmitData && typeof getSubmitData === 'function') {
            let tabData = null
            const result = this.$refs[item].getSubmitData()
            if (result instanceof Promise) {
              tabData = await result
            } else {
              tabData = result
            }
            Object.assign(body, tabData)
          }
        }
        if (body.airlineDetail) {
          body.company.threeCharacterCode = body.airlineDetail.mawbprefix
        }
        if (this.oldData) {
          const nowData = lodash.cloneDeep(body)
          const item = {}
          const nowDataCompany = nowData.company
          if (nowDataCompany) {
            item.branchId = nowDataCompany.branchId
            if (nowDataCompany.uuid) {
              item.companyKey = nowDataCompany.uuid
            } else {
              item.companyKey = null
            }
            if (nowDataCompany.cnShortName != null && nowDataCompany.cnShortName !== '') {
              item.cnShortName = nowDataCompany.cnShortName
            }
            if (nowDataCompany.chineseName != null && nowDataCompany.chineseName !== '') {
              item.chineseName = nowDataCompany.chineseName
            }
            if (nowDataCompany.englishName != null && nowDataCompany.englishName !== '') {
              item.englishName = nowDataCompany.englishName
            }
            if (nowDataCompany.cmpIdx !== 0 && (this.oldData.chineseName !== nowDataCompany.chineseName || this.oldData.cnShortName !== nowDataCompany.cnShortName)) {
              item.cmpIdx = nowDataCompany.cmpIdx
            }
            const isCheck = await this.checkForCompany(item)
            if (!isCheck) {
              loading.close()
              return
            }
          }
        } else {
          // 新增根据参数校验代码是否重复
          const partnersCode = Number(cache.config.get('partnersCode'))
          if ([0, 2, 3].includes(partnersCode)) {
            const company = body.company
            if (company && company.cnShortName) {
              const item = {}
              if (company.cnShortName) {
                item.branchId = company.branchId
                if (company.uuid) {
                  item.companyKey = company.uuid
                } else {
                  item.companyKey = null
                }
                item.cnShortName = company.cnShortName
              }
              const res = await validateCompany(item)
              if (res && res.data && res.data.companyCode) {
                loading.close()
                throw new TabError(this.$t('Partners.duplicatePartnerCodeAlreadyExists'), 'basicInfo')
              }
            }
          }
        }
        if (!body.customerDetail && !this.paramsOfTab.customerDetail.uuid) {
          body.customerDetail = this.paramsOfTab.customerDetail
        }

        loading.close()
        if (body.company) {
          const cmp = {}
          let addedSubsidiaryCompanyKeys = []
          let deletedSubsidiaryCompanyKeys = []
          let supplierDepartmentUuids = []
          for (const key in body.company) {
            if (key === 'addedSubsidiaryCompanyKeys') {
              addedSubsidiaryCompanyKeys = body.company[key]
            }
            if (key === 'deletedSubsidiaryCompanyKeys') {
              deletedSubsidiaryCompanyKeys = body.company[key]
            }
            if (key === 'supplierDepartmentUuids') {
              supplierDepartmentUuids = body.company[key]
            }
            if (typeof body.company[key] === 'object') {
              continue
            }
            cmp[key] = body.company[key]
          }
          body.company = cmp
          body.supplierDepartmentUuids = supplierDepartmentUuids
          body.addedSubsidiaryCompanyKeys = addedSubsidiaryCompanyKeys
          body.deletedSubsidiaryCompanyKeys = deletedSubsidiaryCompanyKeys
          // CARGO-44790 中邮：如果客商的的“应用公司”是豁免分公司时，不再对客户编号、供应商编号的格式进行校验
          const { data: isExclusion } = await areAllExcludedOffices({ officeIds: cmp.multipleBranchId })
          // 校验客户编码和供应商编码
          // CARGO-40303 中邮，合作伙伴新增“内部公司”优化
          if (String(cache.config.get('ToExoSystem')) === 'zy' && !cmp.internalCorrespondent && !isExclusion) {
            // 客户编码 是否为空
            const isEmptyCust = !cmp.externalKeyCust && cmp.customer
            // 供应商编码
            const supplierCodeExist = cmp.bookingAgent || cmp.seaCmpAgent || cmp.overseaAgent ||
              cmp.designationAgent || cmp.localAgent || cmp.settlementAgent || cmp.customsBroker ||
              cmp.warehouse || cmp.truckCmp || cmp.portAgent || cmp.forwardingAgent ||
              cmp.loadingPlaceCompany || cmp.signBillPlaceCompany || cmp.dischargePortCompany ||
              cmp.destinationPortCompany || cmp.terminalCompany
            // 供应商编码 是否为空
            const isEmptyVend = !cmp.externalKeyVend && supplierCodeExist
            // 客户编码和供应商编码校验均为空
            if (isEmptyCust && isEmptyVend) {
              this.$message.warning({ dangerouslyUseHTMLString: true, message: this.$t('Partners.CustomerCodeNotEmpty') + '<br>' + this.$t('Partners.SupplierCodeNotEmpty') })
              return
            }
            // 验证客户编码格式
            let checkCust = false
            let checkVend = false
            if (cmp.externalKeyCust && cmp.customer && !cmp.externalKeyCust.match(new RegExp('^[\\d]{13}$'))) {
              checkCust = true
            }
            // 验证供应商编码格式
            if (cmp.externalKeyVend && supplierCodeExist && !cmp.externalKeyVend.match(new RegExp('^[ABCD]\\d{7}$'))) {
              checkVend = true
            }
            // 均验证失败
            if (checkCust && checkVend) {
              this.$message.warning({
                dangerouslyUseHTMLString: true,
                message: this.$t('Partners.CustomerCodeCheck') + '<br>' + this.$t('Partners.SupplierCodeCheck')
              })
              return
            }
            // 客户编码为空 & 判断供应商编码格式是否错误
            if (isEmptyCust && checkVend) {
              this.$message.warning({
                dangerouslyUseHTMLString: true,
                message: this.$t('Partners.CustomerCodeNotEmpty') + '<br>' + this.$t('Partners.SupplierCodeCheck')
              })
              return
            } else if (isEmptyCust && !checkVend) {
              this.$message.warning(this.$t('Partners.CustomerCodeNotEmpty'))
              return
            } else if (!isEmptyCust && checkVend) {
              this.$message.warning(this.$t('Partners.SupplierCodeCheck'))
              return
            }
            // 供应商编码为空 & 判断客户编码格式是否错误
            if (isEmptyVend && checkCust) {
              this.$message.warning({
                dangerouslyUseHTMLString: true,
                message: this.$t('Partners.SupplierCodeNotEmpty') + '<br>' + this.$t('Partners.CustomerCodeCheck')
              })
              return
            } else if (isEmptyVend && !checkCust) {
              this.$message.warning(this.$t('Partners.SupplierCodeNotEmpty'))
              return
            } else if (!isEmptyVend && checkCust) {
              this.$message.warning(this.$t('Partners.CustomerCodeCheck'))
              return
            }
          }
          if (cmp.externalKeyCust && Number(cache.config.get('isZhongyouAdvancePaymentOpen')) === 1) {
            const item = {}
            item.branchId = cmp.branchId
            item.externalKeyCust = cmp.externalKeyCust
            item.ifAdvancePayment = cmp.ifAdvancePayment
            if (cmp.uuid != null && cmp.uuid) { item.companyKey = cmp.uuid }
            await this.checkForCustomerCode(item)
          }
        }
        if (!body.creditInfo && !this.paramsOfTab.uuid) {
          // 新增时，默认创建信用账款
          body.creditInfo = await this.getCreditInfo()
        }
        // 在保存前进行校验
        if (!(await this.checkBeforeSave())) {
          return
        }
        // 校验车队分类信息
        if (this.paramsOfTab.truckCmp) {
          const truckClassificationForm = this.$refs.truckClassificationForm
          if (truckClassificationForm) {
            const truckClassificationList = truckClassificationForm.rowData || []
            if (truckClassificationList.length === 0) {
              this.$message.warning('"车队分类"必须维护信息')
              this.activeTabName = 'truckClassificationForm'
              if (!this.pendTabSet.has(this.activeTabName)) {
                this.$nextTick(() => {
                  this.handleTabClick()
                })
              }
              return
            }
          }
        }
        loading = getLoading4Cxt(this)
        if (Number(cache.config.get('PartnerManagementMode')) === 0 && body.company && !body.company.uuid) {
          const data = await validateCompanyByChineseNameFunc({ chineseName: body.company.chineseName, branchId: $store.getters.currentOfficeId }).then(res => res.data)
          if (data) {
            const isOk = await this.$confirm(this.$t('CargoMsg.Cargo_ContinueToCreate', [data]), this.$t('common.tips.prompt'), {
              confirmButtonText: this.$t('common.btn.ok'),
              cancelButtonText: this.$t('common.btn.cancel'),
              type: 'warning'
            }).then(() => true).catch(() => false)
            loading.close()
            if (isOk) {
              await this.doCheckNodeAndSave(body, tabNames)
            }
          } else {
            loading.close()
            await this.doCheckNodeAndSave(body, tabNames)
          }
        } else {
          loading.close()
          await this.doCheckNodeAndSave(body, tabNames)
        }
      } catch (err) {
        loading.close()
        if (err instanceof TabError) {
          this.activeTabName = err.tabName
          if (!this.pendTabSet.has(this.activeTabName)) {
            this.$nextTick(() => {
              this.handleTabClick()
            })
          }
          if (err.message) {
            this.$message.warning({ dangerouslyUseHTMLString: true, message: err.message })
          }
          return
        }
        throw err
      }
    },

    async checkForCompany(data) {
      // partnersCode = 3时，不允许编辑非代码不校验
      const partnersCode = Number(cache.config.get('partnersCode'))
      const isAdmin = this.$store.getters.isAdmin
      const res = await validateCompany(data)
      let isCheck = true
      if (isAdmin && partnersCode === 3 && res.data.usedByAccountingDocument) {
        await this.$confirm(this.$t('Partners.usedByVoucherAreYouSureModified'), this.$t('Message.WarmReminder'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          type: 'warning'
        }).then(async() => { isCheck = true }).catch(async() => { isCheck = false })
      }
      if (partnersCode !== 3 && !isAdmin && res.data.usedByAccountingDocument) {
        throw new TabError(this.$t('Partners.usedByVoucherCannotModified'), 'basicInfo')
      }

      // 合作伙伴代码唯一性校验
      const ischeck = this.$refs.basicInfo.isUpdateCnShortName
      if (ischeck && [0, 2, 3].includes(partnersCode)) {
        if (res.data.companyCode) {
          throw new TabError(this.$t('Partners.duplicatePartnerCodeAlreadyExists'), 'basicInfo')
        }
      }
      if (res.data.exist) {
        throw new TabError(this.$t('Partners.partnerSameNameAlreadyExists'), 'basicInfo')
      }
      return isCheck
    },
    async doCheckNodeAndSave(body, tabNames) {
      if (Number(cache.config.get('useCheckRule')) === 1) {
        let checkResult = null
        let needShowDialog = false
        const loading = getLoading4Cxt(this)
        await checkAnyContent(body.company ? body : { ...body, company: this.currentRow }, CheckRuleConstants.NODE_SAVE_PARTNER.code).then(res => {
          checkResult = res.data
          for (const checkRule of checkResult) {
            if (checkRule && checkRule.expressions) {
              for (const item of checkRule.expressions) {
                if (!item.match) {
                  needShowDialog = true
                  break
                }
              }
            }
            if (needShowDialog) {
              break
            }
          }
        }).finally(() => loading.close)
        if (needShowDialog) {
          const callBack = () => { this.doSave(body, tabNames) }
          this.checkingSaveJobWindow.checkNode = CheckRuleConstants.NODE_SAVE_PARTNER.code
          this.checkingSaveJobWindow.rowData = checkResult
          this.checkingSaveJobWindow.callBack = callBack
          this.checkingSaveJobWindow.visible = true
        } else {
          await this.doSave(body, tabNames)
        }
      } else {
        await this.doSave(body, tabNames)
      }
    },
    async doSave(body, tabNames) {
      body.jinRongExchangeMode = this.jinRongExchangeMode
      body.hmToFinanceApi = this.hmToFinanceApi
      let jinRongExchange
      let hmToFinanceApiCustomerResult
      let hmToFinanceApiVendorResult
      const loading = getLoading4Cxt(this)
      try {
        await saveCompanyInfo(body).then(res => {
          const company = res.data.company
          jinRongExchange = res.data.jinRongExchange
          hmToFinanceApiCustomerResult = res.data.hmToFinanceApiCustomerResult
          hmToFinanceApiVendorResult = res.data.hmToFinanceApiVendorResult
          if (this.$refs && this.$refs.basicInfo) {
            this.$refs.basicInfo.isUpdateCnShortName = false
          }
          if (company) {
            company.path = company.uuid
            if (company.globalAccountUuid) {
              const index = this.rowData.findIndex(p => p.uuid === company.globalAccountUuid)
              if (index >= 0) {
                company.path = company.globalAccountUuid + ',' + company.path
              }
            }
            Object.assign(this.currentRow, company)
            const node = this.gridApi.rowModel.rowsToDisplay.find(p => p.data.uuid === company.uuid)
            if (node) {
              node.setData(this.currentRow)
            }
            this.$emit('rowChange', company.uuid)
            // 刷新缓存数据（合作伙伴）
            // syncSpecificBasicData(basicCacheKeys.basic_data_Company)
            updateBasicDataForSingle(basicCacheKeys.basic_data_Company, company)
          } else {
            for (const key in this.currentRow) {
              if (typeof this.currentRow[key] === 'object') {
                this.currentRow[key] = ''
              }
            }
          }
        })
        /* 清空缓存 */
        Company.clearCache(this.currentRow.uuid)
        CreditInfo.clearCache(this.currentRow.cmpIdx)

        // 保存成功后各业签执行的回调方法
        for (const item of tabNames) {
          const executeTask = this.$refs[item].executeTask
          if (executeTask && typeof executeTask === 'function') {
            /* 保存成功后的回调 */
            const result = this.$refs[item].executeTask(this.currentRow)
            if (result instanceof Promise) {
              await result
            }
          }
        }
      } finally {
        loading.close()
      }

      this.againShow('look')
      if (jinRongExchange) {
        if (jinRongExchange.isSuccess) {
          this.$message.success(this.$t('Partners.SuccessSyncCloudAndStarrySky'))
        } else {
          this.$message.warning(this.$t('Partners.FailSyncCloudAndStarrySky', [jinRongExchange.errorMsg]))
        }
      } else {
        this.$message.success(this.$t('Message.SaveSuccessfully'))
      }
      let alertDelayTime = 100
      let hmCustomerExist = false
      let hmSyncCustomerFail = false
      let hmVendorExist = false
      let hmSyncVendorFail = false
      if (hmToFinanceApiCustomerResult) {
        setTimeout(() => {
          if (hmToFinanceApiCustomerResult.isSuccess) {
            this.$message.success(this.$t('Partners.HMSyncYongYouSuccess', [hmToFinanceApiCustomerResult.successMsg]))
          } else {
            if (hmToFinanceApiCustomerResult.errorMsg === '相同名称和代码客户已存在') {
              hmCustomerExist = true
            } else {
              this.$message.warning(this.$t('Partners.HMSyncYongYouFail', [hmToFinanceApiCustomerResult.errorMsg]))
              hmSyncCustomerFail = true
            }
          }
        }, alertDelayTime)
        alertDelayTime += 100
      }
      if (hmToFinanceApiVendorResult) {
        setTimeout(() => {
          if (hmToFinanceApiVendorResult.isSuccess) {
            this.$message.success(this.$t('Partners.HMSyncYongYouSuccess2', [hmToFinanceApiVendorResult.successMsg]))
          } else {
            if (hmToFinanceApiVendorResult.errorMsg === '相同名称和代码供应商已存在') {
              hmVendorExist = true
            } else {
              this.$message.warning(this.$t('Partners.HMSyncYongYouFail2', [hmToFinanceApiVendorResult.errorMsg]))
              hmSyncVendorFail = true
            }
          }
        }, alertDelayTime)
        alertDelayTime += 100
      }
      if (hmToFinanceApiCustomerResult || hmToFinanceApiVendorResult) {
        setTimeout(async() => {
          if (hmCustomerExist || hmVendorExist) {
            let msg = ''
            if (hmCustomerExist) {
              if (hmVendorExist) {
                msg = this.$t('Information.ExistCustomerVendorException')
              } else {
                msg = this.$t('Information.ExistCustomerCodeExcepiton')
              }
            } else {
              msg = this.$t('Information.ExistVendorCodeException')
            }
            await this.$confirm(msg, this.$t('common.tips.prompt'), {
              confirmButtonText: this.$t('common.btn.ok'),
              showCancelButton: false,
              type: 'warning'
            }).catch(() => {})
          }
          if (hmSyncCustomerFail || hmSyncVendorFail) {
            let msg = ''
            if (hmSyncCustomerFail) {
              if (hmSyncVendorFail) {
                msg = this.$t('Information.SyncCustomerVendorException')
              } else {
                msg = this.$t('Information.SyncCustomerCodeExcepiton')
              }
            } else {
              msg = this.$t('Information.SyncVendorCodeException')
            }
            this.$confirm(msg, this.$t('common.tips.prompt'), {
              confirmButtonText: this.$t('common.btn.ok'),
              showCancelButton: false,
              type: 'warning'
            }).catch(() => {})
          }
        }, alertDelayTime)
      }
    },
    // 在保存前进行校验
    async checkBeforeSave() {
      const company = this.paramsOfTab
      const res = await checkOtherCompanySettleAgent({ companyUuid: company.uuid })
      if (res.data && res.data.length > 0) {
        if (!res.data[0]) return true
        let msg = `
          <label>${this.$t('Partners.companyIsSettlementAgentFollowingPartners')}</label><br/>
          <label>${this.$t('Partners.confirmDisassociateAndSaveModification')}?</label><br/>
          <table border="1" width="100%">
            <tr>
              <td style="background-color: #f0f2f5">${this.$t('Partners.chineseName')}</td>
              <td style="background-color: #f0f2f5">${this.$t('Partners.affiliatedBranch')}</td>
            </tr>`
        for (const resultElement of res.data) {
          if (!resultElement) continue
          msg += `<tr><td>${resultElement.NAME}</td><td>${resultElement.CODE}</td></tr>`
        }
        msg += `</table>`
        return await this.$confirm(msg, { dangerouslyUseHTMLString: true, closeOnClickModal: false }).then(() => true).catch(() => false)
      }
      return true
    },
    toAudit() {
      this.$emit('audit', this.currentRow)
    },
    updatePartnerFormRow(row) {
      const node = this.gridApi.rowModel.rowsToDisplay.find(p => p.data.uuid === row.uuid)
      if (node) {
        node.setData(row)
      }
    },
    toCancelAudit() {
      const row = this.currentRow
      const params = { uuidList: [row.uuid] }
      this.loading = getLoading()
      cancelAuditCompany(params).then(res => {
        this.$message.success(this.$t('CargoMsg.Cargo_ReviewCancelledSuccessfully'))
        // 刷新页面
        const resultData = res.data
        if (resultData.length > 0) {
          Object.assign(this.currentRow, resultData[0])
          // 刷新缓存数据（合作伙伴）
          updateBasicDataForSingle(basicCacheKeys.basic_data_Company, this.currentRow)
          this.$emit('refresh-data', this.currentRow)
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    goBack() {
      this.activeTabName = 'basicInfo'
      this.$emit('back')
    },
    editHandler() {
      this.checkReloadPartner()
    },
    checkReloadPartner() {
      const partner = this.currentRow
      // if (partner.branchId !== this.$store.getters.currentOfficeId) {
      //   this.$confirm(this.$t('Partners.EidtBranchNotSameTip'), this.$t('common.tips.prompt'), {
      //     confirmButtonText: this.$t('Message.GotIt'),
      //     showCancelButton: false,
      //     type: 'warning'
      //   })
      //   return
      // }
      // if (!this.partnerPrivilegeBranches.includes(this.$store.getters.currentOfficeId)) {
      //   this.$message.warning(this.$t('Partners.BranchNoPartnerPermission'))
      //   return
      // }
      if (partner && (partner.designationAgent || partner.overseaAgent)) {
        // 海外代理权限判断  filter,partner,overseasAgent
        if (this.serviceType === PartnerServiceItem.PARTNER_AGENT.code) {
          if (!this.$checkPermission(['filter_fmAgentPartners_agencyEdit'])) {
            this.$message.info(this.$t('Partners.notPermissionEditOverseasAgent'))
            return
          }
        } else {
          if (this.serviceType === PartnerServiceItem.PARTNER_SERVICE_ALL.code && !this.$checkPermission(['filter_partner_overseasAgent'])) {
            this.$message.info(this.$t('Partners.notPermissionEditOverseasAgent'))
            return
          }
        }
      }
      if (partner && partner.airCmp) {
        // 航空公司权限判断  filter,fmAirline,airEdit
        if (this.serviceType === PartnerServiceItem.AIRLINE_COMPANY.code) {
          if (!this.$checkPermission(['filter_fmAirline_airEdit'])) {
            this.$message.info(this.$t('Partners.notPermissionEditCarrier'))
            return
          }
        } else {
          if (this.serviceType === PartnerServiceItem.PARTNER_SERVICE_ALL.code && !this.$checkPermission(['filter_partner_airCarrier'])) {
            this.$message.info(this.$t('Partners.notPermissionEditCarrier'))
            return
          }
        }
      }
      if (partner && partner.seaCmp) {
        // 船公司权限判断  filter,fmShipping,shippingEdit
        if (this.serviceType === PartnerServiceItem.SHIPPING_COMPANY.code) {
          if (!this.$checkPermission(['filter_fmShipping_shippingEdit'])) {
            this.$message.info(this.$t('Partners.notPermissionEditCarrier'))
            return
          }
        } else {
          if (this.serviceType === PartnerServiceItem.PARTNER_SERVICE_ALL.code && !this.$checkPermission(['filter_partner_seaCarrier'])) {
            this.$message.info(this.$t('Partners.notPermissionEditCarrier'))
            return
          }
        }
      }
      this.againShow('edit')
    },
    onRowChange(uuid) {
      this.$emit('rowChange', uuid)
    },
    // 校验预付款客户
    async checkForCustomerCode(data) {
      const res = await validateCustomerCode(data)
      // 14 初始化余额之后， ”预付款”客户 不可切换回 “欠计”
      if (data.externalKeyCust && res.data.balanceInitialized) {
        throw new TabError(this.$t('AdvancePayment.BalanceInitialized'), 'basicInfo')
      }
      // 预付款客户不允许维护相同编码，维护相同提示“客户编码重复”
      if (data.externalKeyCust && res.data.CustomerCodeDuplicate) {
        throw new TabError(this.$t('AdvancePayment.CustomerCodeDuplicate'), 'basicInfo')
      }
    },
    async getCreditInfo() {
      const creditInfo = new CreditInfo().fillDefaultValue().getData()
      // REQ-0022 新增合作伙伴 ETD 天数默认 100（财务风控：超 ETD 100 天应收未核销卡单）
      creditInfo.etdDays = 100
      // CARGO-37796 信用账款的预设设置
      await getDefaultCreditInfo({ branchId: this.currentRow.branchId }).then(res => {
        const data = res.data
        if (data && data.uuid) {
          creditInfo.creditDateType = data.creditDateType
          creditInfo.currency = data.currency
          creditInfo.remarks = data.remarks
          creditInfo.creditDateLimited = data.creditDateLimited
          creditInfo.credit = data.credit
          creditInfo.termUnit = data.termUnit
          creditInfo.depositCurrency = 'RMB'
          creditInfo.depositType = 2
        } else {
          creditInfo.creditDateType = -1
          creditInfo.currency = 'RMB'
          creditInfo.remarks = 'ETD'
          creditInfo.depositCurrency = 'RMB'
          creditInfo.depositType = 2
        }
      })
      return creditInfo
    }
  }
}
</script>

<style scoped lang="scss">
#app .details-view .grid-fill ::v-deep {
  width: 100%;
  min-width: 160px;
  height: 100%;
  flex-direction: row;
  .ag-theme-balham {
    .ag-header-container {
      width: 100% !important;
      .ag-header-row {
        width: 100% !important;
        .ag-header-cell {
          width: 100% !important;
          .ag-header-cell-resize {
            display: none;
          }
        }
      }
    }
    .ag-center-cols-container {
      width: 100% !important;
      .ag-row {
        .ag-cell {
          width: 100% !important;
        }
      }
    }
  }
}

.upload-file-row {
  display: flex;
  align-items: center;
}

.upload-file-name {
  max-width: 360px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.upload-file-remove {
  padding: 0 4px;
  margin-left: 6px;
  line-height: 1;
}
</style>
